import { styled, css } from 'styled-components';
import { BoxProps, overflows } from '.';

interface TransientProps {
  $overflow?: (typeof overflows)[number];
}

export const Container = styled.div<Omit<BoxProps, 'overflow' | 'semantic'> & TransientProps>`
  ${({
    theme: { colors, spacings },
    alignSelf = 'auto',
    contentAlignment = 'flex-start',
    contentJustify = 'flex-start',
    flex,
    fullWidth,
    horizontalGap = 's0',
    margin = ['s0', 's0', 's0', 's0'],
    orientation = 'row',
    $overflow = 'wrap',
    padding = ['s0', 's0', 's0', 's0'],
    verticalGap = 's0',
  }) => css`
    align-self: ${alignSelf};
    align-items: ${contentAlignment};
    display: flex;
    flex: ${flex || 'unset'};
    flex-direction: ${orientation};
    gap: ${spacings[verticalGap as keyof typeof spacings]} ${spacings[horizontalGap as keyof typeof spacings]};
    justify-content: ${contentJustify};
    margin: ${spacings[margin[0] as keyof typeof spacings]} ${spacings[margin[1] as keyof typeof spacings]}
      ${spacings[margin[2] as keyof typeof spacings]} ${spacings[margin[3] as keyof typeof spacings]};
    padding: ${spacings[padding[0] as keyof typeof spacings]} ${spacings[padding[1] as keyof typeof spacings]}
      ${spacings[padding[2] as keyof typeof spacings]} ${spacings[padding[3] as keyof typeof spacings]};
    scrollbar-width: thin;
    scrollbar-color: ${colors.brandDarkAlpha20} transparent;
    ${
      fullWidth &&
      css`
        width: 100%;
      `
    }
    ${
      $overflow === 'wrap' &&
      css`
        flex-wrap: wrap;
      `
    }

    ${
      $overflow === 'nowrap' &&
      css`
        flex-wrap: nowrap;
      `
    }

    ${
      orientation === 'row' &&
      css`
        ${
          $overflow === 'scroll' &&
          css`
            overflow-x: auto;
          `
        }
      `
    }

    ${
      orientation === 'column' &&
      css`
        ${
          $overflow === 'scroll' &&
          css`
            overflow-y: auto;
          `
        }
      `
    }

    &::-webkit-scrollbar {
      height: 0.375rem;
      width: 0.375rem;
    }

    &::-webkit-scrollbar-thumb {
      background: ${colors.brandDarkAlpha20};
      border-radius: 7em;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }
  `}
`;
